import { render, staticRenderFns } from "./SelectFontWrap.vue?vue&type=template&id=2de74642&scoped=true&"
import script from "./SelectFontWrap.vue?vue&type=script&lang=js&"
export * from "./SelectFontWrap.vue?vue&type=script&lang=js&"
import style0 from "./SelectFontWrap.vue?vue&type=style&index=0&id=2de74642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de74642",
  null
  
)

export default component.exports